
import '../../../vendor/gentelella/css/custom.css'


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/styles/gentelella/index.ts